import ColouredRoundWrapper from "../UI/wrappers/ColouredRoundWrapper";
import { ReactComponent as SearchIcon } from "../../assets/icons/search.svg";
import { ReactComponent as XIcon } from "../../assets/icons/x_grey.svg";
import searchStyles from "../../styles/search.module.css";
import labels from "../../utils/labels";

const SearchBar = ({
  input,
  appliedFilters,
  onInputChange,
  onClearAll,
  placeholder,
}: {
  input: string;
  appliedFilters?: React.ReactNode[];
  onInputChange: (value: string) => void;
  onClearAll: () => void;
  placeholder: string;
}) => {
  const hasAppliedFilters = appliedFilters && appliedFilters.length > 0;

  return (
    <ColouredRoundWrapper
      bgColor="white"
      padding
      width={"100%"}
      borderColor="var(--col-border-primary)"
      classes="!gap-[var(--spacing-sm)]"
    >
      <SearchIcon />

      {hasAppliedFilters && (
        <div className="flex flex-row">{appliedFilters}</div>
      )}

      <input
        type="text"
        value={input}
        onChange={(e) => onInputChange(e.target.value)}
        placeholder={placeholder}
        className={`bg-transparent ${searchStyles.searchInputField} w-[100%] focus:outline-none`}
        style={{ height: "100%" }}
      />

      {hasAppliedFilters && (
        <div className="min-w-[14px] cursor-pointer" onClick={onClearAll}>
          <XIcon width={14} height={14} />
        </div>
      )}
    </ColouredRoundWrapper>
  );
};

export default SearchBar;
